import { render, staticRenderFns } from "./EntityFieldDetailedView.vue?vue&type=template&id=6d6231f3&scoped=true"
import script from "./EntityFieldDetailedView.vue?vue&type=script&lang=js"
export * from "./EntityFieldDetailedView.vue?vue&type=script&lang=js"
import style0 from "./EntityFieldDetailedView.vue?vue&type=style&index=0&id=6d6231f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6231f3",
  null
  
)

export default component.exports